// extracted by mini-css-extract-plugin
export default {"custom_button":"styles_custom_button__5WxkI"};